let isEmptyObj
export default isEmptyObj = (object) => {
    for (var key in object) {
        if (object.hasOwnProperty(key)) {
            return false;
        }
    }
}